(() => {
  const BASE_COLLECTION_URL = '/collections/all-skins';
  const SEARCH_URL = '/search';

  const directMatches = new Map([
    ['ps5 controller', [
      ['filter.p.m.custom.console_brands', 'Playstation'],
      ['filter.p.product_type', 'Controller']
    ]],
    ['playstation controller', [
      ['filter.p.m.custom.console_brands', 'Playstation'],
      ['filter.p.product_type', 'Controller']
    ]],
    ['playstation 5 controller', [
      ['filter.p.m.custom.console_brands', 'Playstation'],
      ['filter.p.product_type', 'Controller']
    ]],
    ['dualsense', [
      ['filter.p.m.custom.console_brands', 'Playstation'],
      ['filter.p.product_type', 'Controller']
    ]],
    ['xbox controller', [
      ['filter.p.m.custom.console_brands', 'Xbox'],
      ['filter.p.product_type', 'Controller']
    ]],
    ['xbox series controller', [
      ['filter.p.m.custom.console_brands', 'Xbox'],
      ['filter.p.product_type', 'Controller']
    ]],
    ['switch pro', [
      ['filter.p.m.custom.console_brands', 'Nintendo'],
      ['filter.p.m.custom.device_compatibility', 'Nintendo Switch Pro Controller']
    ]],
    ['nintendo switch pro controller', [
      ['filter.p.m.custom.console_brands', 'Nintendo'],
      ['filter.p.m.custom.device_compatibility', 'Nintendo Switch Pro Controller']
    ]],
    ['anime', [
      ['filter.p.m.custom.design_style', 'Anime']
    ]]
  ]);

  const searchFallbacks = new Map([
    ['minimal', 'minimal'],
    ['clean', 'minimal OR clean OR sleek OR simple'],
    ['dark', 'dark OR black OR shadow OR stealth']
  ]);

  const normalizeQuery = (query) => String(query || '')
    .toLowerCase()
    .replace(/['"`]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\bplaystation\s*5\b/g, 'ps5')
    .replace(/\bxbox\s+series\s+x\s+controller\b/g, 'xbox controller')
    .replace(/\bxbox\s+series\s+s\s+controller\b/g, 'xbox controller')
    .replace(/\bnintendo\s+switch\s+pro\b/g, 'switch pro')
    .trim()
    .replace(/\s+/g, ' ');

  const collectionUrl = (pairs) => {
    const params = new URLSearchParams();
    pairs.forEach(([key, value]) => params.append(key, value));
    params.set('sort_by', 'title-ascending');
    return `${BASE_COLLECTION_URL}?${params.toString()}`;
  };

  const searchUrl = (query) => {
    const params = new URLSearchParams();
    params.set('q', query);
    params.set('type', 'product');
    params.set('options[prefix]', 'last');
    return `${SEARCH_URL}?${params.toString()}`;
  };

  const getIntentUrl = (query) => {
    const normalizedQuery = normalizeQuery(query);
    if (!normalizedQuery) return '';

    if (directMatches.has(normalizedQuery)) {
      return collectionUrl(directMatches.get(normalizedQuery));
    }

    if (searchFallbacks.has(normalizedQuery)) {
      return searchUrl(searchFallbacks.get(normalizedQuery));
    }

    const pairs = [];

    if (/\b(ps5|playstation)\b/.test(normalizedQuery)) {
      pairs.push(['filter.p.m.custom.console_brands', 'Playstation']);
    } else if (/\bxbox\b/.test(normalizedQuery)) {
      pairs.push(['filter.p.m.custom.console_brands', 'Xbox']);
    } else if (/\b(switch|nintendo)\b/.test(normalizedQuery)) {
      pairs.push(['filter.p.m.custom.console_brands', 'Nintendo']);
    }

    if (/\b(controller|remote|dualsense)\b/.test(normalizedQuery)) {
      pairs.push(['filter.p.product_type', 'Controller']);
    } else if (/\b(console)\b/.test(normalizedQuery)) {
      pairs.push(['filter.p.product_type', 'Console']);
    } else if (/\b(handheld)\b/.test(normalizedQuery)) {
      pairs.push(['filter.p.product_type', 'Handheld']);
    }

    if (/\banime\b/.test(normalizedQuery)) {
      pairs.push(['filter.p.m.custom.design_style', 'Anime']);
    }

    return pairs.length ? collectionUrl(pairs) : '';
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[role="search"], form.search');
    if (!form) return;

    const input = form.querySelector('input[name="q"], input[type="search"]');
    const intentUrl = getIntentUrl(input?.value);

    if (!intentUrl) return;

    event.preventDefault();
    event.stopPropagation();
    window.location.href = intentUrl;
  }, true);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-gizmo-search-url]');
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();
    window.location.href = trigger.dataset.gizmoSearchUrl;
  }, true);

  window.GizmoSearchIntent = {
    getIntentUrl,
    normalizeQuery
  };
})();
